import React from 'react'
import './WorkDescription.css'

function WorkDescription(props) {
    return (
        <div className="workDescription">
            <div className="workDescription__right">
                <h3 className="workDescription__title">{props.title}</h3>
                <p className="workDescription__subTitle">{props.subtitle}</p>
                <hr className="workDescription__hrRight" />
                <p className="workDescription__description">
                    <a target="_blank" className="workDescription__links" href={props.seeLive}>See Live</a>
                    <a target="_blank" className="workDescription__links" href={props.sourceCode}>Source Code</a>
                </p>
            </div>
        </div>
    )
}

export default WorkDescription
